import React from "react";
import { SupplyDemandProviderMap } from "./SupplyDemandProviderMap";

export const SupplyDemandMapDemo: React.FC<{}> = () => {
    return (
        <SupplyDemandProviderMap
            metadata={{
                providerName: "Banana Shire Council",
                schemeMetadata: [
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Banana Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                processed:
                                    "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                format: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Baralaba Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                processed:
                                    "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                format: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Biloela Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                processed:
                                    "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                format: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Callide Dam Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                processed:
                                    "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                format: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Goovigen Water Supply",
                        schemeId: "2102",
                        comments: []
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Moura Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                processed:
                                    "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                format: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Taroom Water Supply",
                        schemeId: "2102",
                        comments: []
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Thangool Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                processed:
                                    "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam.",
                                format: "Ongoing drought conditions, declining levels in Callide Dam, Groundwater dependent on replenishment from Callide Dam."
                            }
                        ]
                    },
                    {
                        longLabel: "Confidence that water demands will be met over the next 5 years",
                        schemeName: "Theodore Water Supply",
                        schemeId: "2102",
                        comments: [
                            {
                                value: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                processed:
                                    "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall.",
                                format: "This is a reflection on the nature of the Dawson River Schemes, on stream storage limitations, and dependence on regular rainfall."
                            }
                        ]
                    }
                ]
            }}
            providerName={"Banana Shire Council"}
            providerAdminId={"BANASC"}
            spatialValues={[
                { adminId: "Banana Water Supply", name: "Banana Water Supply", category: "unsure" },
                { adminId: "Baralaba Water Supply", name: "Baralaba Water Supply", category: "unsure" },
                { adminId: "Biloela Water Supply", name: "Biloela Water Supply", category: "unsure" },
                { adminId: "Callide Dam Water Supply", name: "Callide Dam Water Supply", category: "unsure" },
                { adminId: "Goovigen Water Supply", name: "Goovigen Water Supply", category: "unsure" },
                { adminId: "Moura Water Supply", name: "Moura Water Supply", category: "unsure" },
                { adminId: "Taroom Water Supply", name: "Taroom Water Supply", category: "high" },
                { adminId: "Thangool Water Supply", name: "Thangool Water Supply", category: "unsure" },
                { adminId: "Theodore Water Supply", name: "Theodore Water Supply", category: "unsure" },
                { adminId: "BANASC", category: "providerGeometry", name: "Banana Shire Council" }
            ]}
        />
    );
};
